import React, { useState, useEffect, useRef } from 'react';
import ReactTable from 'react-table';
import Button from '../button/Button';
import Pagination from '../common/Pagination';
import 'react-table/react-table.css';
import { withRouter } from 'react-router';
import Loader from '../common/Loader';
import moment from 'moment';
import Toaster from '../common/Toaster';
import { STATUS_CODES, TABLE } from '../../helper/constant';
import Api from '../../helper/Api';
import CommonModel from '../common/CommonModel';
import View from './ViewModal';
import RoyTooltip from '../common/RoyTooltip';
import AuthActions from '../../redux/auth/actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
const { admin } = AuthActions;

const ShareContentTable = (props) => {
	const [tblData, settblData] = useState();
	const [loader, setLoader] = useState(false);
	const [pages, setPages] = useState(0);
	const [activePage, setActivePage] = useState(0);
	const [field, setField] = useState('updatedAt');
	const [sortBy, setSortBy] = useState('DESC');
	const [modal, setModal] = useState(false);
	const [staticContentData, setStaticContentData] = useState({});
	const [view, setView] = useState(false);
	const toaster = useRef();

	useEffect(() => {
		getList(field, sortBy, activePage + 1);
		setPages(1);
	}, []);
	// const { role } = props;
	const columns = [
		{
			Header: 'Title',
			accessor: 'title',
			className: 'text-center',
			filterable: false,
			headerClassName: 'react-table-header-class',
		},
		{
			Header: 'Date',
			accessor: 'updatedAt',
			className: 'text-center',
			filterable: false,
			headerClassName: 'react-table-header-class',
			Cell: (props) => <div>{moment(props.original.updatedAt).format('MMM-DD-YYYY')}</div>,
		},
		{
			Header: 'Action',
			accessor: 'action',
			className: 'text-center',
			headerClassName: 'react-table-header-class',
			sortable: false,
			filterable: false,
			width: 280,
			Cell: (props) => (
				<div className="react-action-class">
					<div>
						<RoyTooltip id={`view-${props.original.id}`} title={'View'} placement="left">
							<Button
								className="c-btn c-primary mr-10"
								style={{ minWidth: '50px' }}
								onClick={() => {
									setView(true);
									setModal(true);
									setStaticContentData(props.original);
								}}
								id={`view-${props.original.id}`}
							>
								<div className="fs-14 medium-text">
									<i className="fas fa-info  " />
								</div>
							</Button>
						</RoyTooltip>
						<div className="file-upload">
							<label className="c-btn fs-16 form-button demi-bold-text mt-15" style={{ backgroundColor: 'orange' }}>
								Upload File
								{props.original.assetType === 'IMAGE' ? (
									<input
										id="fileName"
										className="file-upload__input"
										name="file-upload"
										type="file"
										accept="image/jpg,image/png,image/jpeg"
										onChange={(e) => {
											return handleImage(e, props.original.title);
										}}
									/>
								) : (
									<input
										id="fileName"
										className="file-upload__input"
										name="file-upload"
										type="file"
										accept="video/mp4"
										onChange={(e) => {
											return handleImage(e, props.original.title);
										}}
									/>
								)}
							</label>
						</div>
					</div>
				</div>
			), // Custom cell components!
		},
	];

	const onChangePageGetData = (state) => {
		if (state.page !== activePage) {
		}
	};

	const handleImage = (e, title) => {
		if (e.target.files[0]) {
			let asset = e.target.files[0];
			let params = {
				title,
				asset,
			};
			const formData = new FormData();
			for (let key in params) {
				formData.append(key, params[key]);
			}
			setLoader(true);

			Api('POST', 'cms/static/upload/asset', formData)
				.then((res) => {
					if (res.status === 200) {
						if (toaster.current) toaster.current.success(res.data.message);
						// setTimeout((res) => {
						props.history.push('/static-content');
						getList(field, sortBy, activePage + 1);
						// }, 1000);
						setLoader(false);
					} else {
						if (toaster.current) toaster.current.error(res.data.message);
						setLoader(false);
					}
				})
				.catch((err) => {
					if (toaster.current) toaster.current.error(err.response);
					setLoader(false);
				});
		}
	};

	function getList(field = 'updatedAt', sortBy = 'DESC', search = '', page = '1') {
		const params = {
			sort_by: field,
			order: sortBy,
			search: search,
			page: page,
		};
		setLoader(true);

		Api('POST', 'cms/static/list/content', params)
			.then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					settblData(res.data.data.rows);
					setPages(Math.ceil(res.data.data.count / TABLE.LIMIT));
					setLoader(false);
				} else {
					if (toaster.current) toaster.current.error(res.data.message);
				}
			})
			.catch((err) => {
				if (toaster.current) toaster.current.error(err.response);
			});
	}

	return (
		<div>
			<div className="plr-15">
				<div className="roe-card-style mtb-15">
					<div className="roe-card-header module-header">
						<div className="flex-1 fs-16 demi-bold-text" />
					</div>
					<div className="roe-card-body">
						<ReactTable
							style={{
								border: 'none',
								boxShadow: 'none',
							}}
							data={tblData}
							columns={columns}
							defaultPageSize={10}
							filterable
							minRows={2}
							manual
							defaultFilterMethod={(filter, row) => {
								const id = filter.pivotId || filter.id;

								return row[id] !== undefined
									? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
									: true;
							}}
							className="-striped -highlight custom-react-table-theme-class"
							pages={pages}
							page={activePage}
							PaginationComponent={Pagination}
							loading={loader}
							LoadingComponent={Loader}
							onFetchData={onChangePageGetData}
							onPageChange={(pageIndex) => {
								setActivePage(pageIndex);
								getList(field, sortBy, pageIndex + 1);
							}}
							onSortedChange={(sortProperties) => {
								const sort = sortProperties[0].desc ? 'DESC' : 'ASC';
								setSortBy(sort);
								setActivePage(0);
								setField(sortProperties[0].id);
								getList(sortProperties[0].id, sort, 1);
							}}
						/>
					</div>

					{view && (
						<CommonModel
							modal={modal}
							size="xl"
							style={{ maxWidth: '1600px', width: '60%' }}
							children={
								<View
									staticContentData={staticContentData}
									toggle={() => {
										setModal(false);
									}}
								/>
							}
						/>
					)}
				</div>
			</div>
			<Toaster ref={toaster} />
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		role: state.auth.role,
		id: state.auth.id,
		...state.themeChanger,
	};
};
export default compose(withRouter, connect(mapStateToProps, { admin }))(ShareContentTable);
